import React from 'react';
import classNames from 'classnames/bind';
import { IconSlidersFill } from '@saucelabs/ds-icons';

import Styles from './FilterToggle.styles';

const context = classNames.bind(Styles);

export type FilterToggleProps = {
  activeFilters: number;
  keyboardShortcuts?: boolean;
  showFilters: boolean;
  toggleFilterView: () => void;
};

const FilterToggle: React.FC<FilterToggleProps> = ({
  activeFilters,
  keyboardShortcuts = false,
  showFilters,
  toggleFilterView,
}) => (
  <div
    className={`${Styles.default} border-0 border-l border-solid border-gray-200`}
    data-qa="manual-search-filter-toggle"
  >
    <button
      aria-label="toggle-filter"
      className={context('button', 'bg-white',
        'focus:outline-none', 'focus:bg-gray-50', 'active:outline-none',
        { 'bg-gray-50': showFilters },
      )}
      onClick={toggleFilterView}
      type="button"
    >
      <IconSlidersFill />
      <div className={`${Styles.label} text-gray-600`}>
        { keyboardShortcuts ? (
          <>
            <u>F</u>
            ilters
          </>
        ) : 'Filters'}
      </div>
      <div
        className={`${Styles.number} text-blue-700`}
        data-qa="manual-search-filter-toggle-active-filter-number"
      >
        {`(${activeFilters})`}
      </div>
    </button>
  </div>
);

export default FilterToggle;
